import React, { useState } from 'react';
import { adminProductApi } from '../../../../api/adminProductApi';
import MobileProductDialog from './MobileProductDialog';
import MobileProductField from './MobileProductField';
import MobileProductHint from './MobileProductHint';
import MobileProductFeedback from './MobileProductFeedback';
import useMobileMutation from './useMobileMutation';
import { isIntegerAmount, readNumber } from './mobileProductUtils';
import { physicalStockQuantity } from '../../../../utils/stockQuantities';

export default function MobileProductReceipt({ product, onSaved, onClose }) {
  const [quantity, setQuantity] = useState('');
  const [price, setPrice] = useState('');
  const mutation = useMobileMutation();
  const save = () => {
    if (!isIntegerAmount(quantity) || Number(quantity) <= 0) {
      mutation.setError('Вкажіть цілу кількість більшу за нуль');
      return;
    }
    if (!Number.isFinite(readNumber(price))) {
      mutation.setError('Вкажіть невід’ємну закупівельну ціну');
      return;
    }
    mutation.run(
      () => adminProductApi.addProductQuantity(product.id, Number(quantity), readNumber(price)),
      () => {
        onClose();
        onSaved('Надходження записано в історію залишків');
      },
    );
  };
  return (
    <MobileProductDialog
      size='compact'
      title='Надходження товару'
      subtitle={`#${product.id} · ${product.name}`}
      busy={mutation.busy}
      onClose={onClose}
      onSubmit={save}
      footer={
        <>
          <button
            type='button'
            className='btn btn-outline-secondary'
            disabled={mutation.busy}
            onClick={onClose}
          >
            Скасувати
          </button>
          <button type='submit' className='btn btn-dark' disabled={mutation.busy}>
            {mutation.busy ? 'Збереження…' : 'Додати на склад'}
          </button>
        </>
      }
    >
      <MobileProductFeedback error={mutation.error} />
      <div className='mp-receipt-stock' aria-live='polite'>
        <span>
          На складі <strong>{physicalStockQuantity(product)} шт.</strong>
        </span>
        <i className='bi bi-arrow-right' aria-hidden='true' />
        <span>
          Надійде{' '}
          <strong>
            {isIntegerAmount(quantity) ? Number(quantity) : 0} шт.
          </strong>
        </span>
      </div>
      <fieldset disabled={mutation.busy}>
        <MobileProductField
          label='Кількість надходження, шт.'
          type='number'
          min='1'
          inputMode='numeric'
          autoFocus
          value={quantity}
          onChange={setQuantity}
        />
        <MobileProductField
          label='Закупівельна ціна за одиницю, грн'
          inputMode='decimal'
          value={price}
          placeholder='0,00'
          onChange={setPrice}
        />
      </fieldset>
      <MobileProductHint>
        Товари для очікуючих замовлень резервуються автоматично. Решта залишається на складі.
        Для виправлення кількості відкрийте редагування товару й укажіть причину.
      </MobileProductHint>
    </MobileProductDialog>
  );
}
